(function ($) {
  $(document).ready(function () {
    if ($("#SlideshowWrapper-slideshow-1 .slideshow__image").length) {
      var bannerTextAnimation = setInterval(function () {
        if (
          $("#SlideshowWrapper-slideshow-1 .slideshow__image").hasClass(
            "lazyloaded"
          )
        ) {
          setTimeout(function () {
            $(
              "#SlideshowWrapper-slideshow-1 .slideshow__text-content .container>.d-inline-block"
            ).addClass("activate-animation");
          }, 500);
          clearInterval(bannerTextAnimation);
        }
      }, 100);
    }
  });
})(jQuery);
